import { render, staticRenderFns } from "./PhoneDetail.vue?vue&type=template&id=3b3a7728&"
import script from "./PhoneDetail.vue?vue&type=script&lang=js&"
export * from "./PhoneDetail.vue?vue&type=script&lang=js&"
import style0 from "./PhoneDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports